import { ContentProviderType } from "../enums";

export interface AccountConfigurationContentProviderDto {
  title?: string;
  isEnabled: boolean;
  providerType: ContentProviderType;
  credentials: AccountConfigurationContentProviderCredentialsDto;
}

export interface AccountConfigurationContentProviderCredentialsDto {
  username?: string;
  apiKey?: string;
}
